import axios from "axios";
import { useCallback } from "react";
import SideNavbar from "../../../components/common/SideNavbar";
import TopNavbar from "../../../components/common/TopNavbar";
import { useEffect, useState } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import DataTable from "react-data-table-component";
import {
  userTableCustomStyles,
  tariffChargeTableCustomStyles,
} from "../../../utils/TableCustomStyles";
import { Stepper, Step } from "react-form-stepper";
import "../../../components/css/StepperForm.css";
import PlaceholderPicture from "../../../images/placeholder-profile.png";
import Select from "react-select";
import { format } from "date-fns";

function AgentMaster() {
  const steps = ["Primary Details", "Financial Details"];
  const [activeStep, setActiveStep] = useState(0);

  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [customerBranchData, setCustomerBranchData] = useState([]);
  const [agentUserData, setAgentUserData] = useState([]);
  const [agentTariffData, setAgentTariffData] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] =
    useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [agentForDelete, setAgentForDelete] = useState("");
  const [showDeleteAgentLoader, setShowDeleteAgentLoader] = useState(false);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const [loggedInUser, setLoggedInUser] = useState(null);

  // Canvas visibility
  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showUpdateCanvas, setShowUpdateCanvas] = useState(false);
  const [canvasAddFullScreen, setCanvasAddFullScreen] = useState(false);
  const [canvasUpdateFullScreen, setCanvasUpdateFullScreen] = useState(false);

  // Tabs for update canvas
  const [showUpdateAgentDetails, setShowUpdateAgentDetails] = useState(true);
  const [showUpdateAgentContactDetails, setShowUpdateAgentContactDetails] =
    useState(false);
  const [showUpdateAgentUploadsDetails, setShowUpdateAgentUploadsDetails] =
    useState(false);
  const [showUpdateAgentUserDetails, setShowUpdateAgentUserDetails] =
    useState(false);
  const [showUpdateAgentTariffDetails, setShowUpdateAgentTariffDetails] =
    useState(false);

  // Loaders
  const [showAddLoader, setShowAddLoader] = useState(false);
  const [showUpdateLoader, setShowUpdateLoader] = useState(false);
  const [showAddAgentContactLoader, setShowAddAgentContactLoader] =
    useState(false);
  const [showUpdateAgentContactLoader, setShowUpdateAgentContactLoader] =
    useState(false);
  const [showDeleteAgentContactLoader, setShowDeleteAgentContactLoader] =
    useState(false);
  const [showAgentUploadFilesLoader, setShowAgentUploadFilesLoader] =
    useState(false);
  const [
    showDeleteAgentUploadFilesLoader,
    setShowDeleteAgentUploadFilesLoader,
  ] = useState(false);

  // ---------- Add form state ----------
  const [agentName, setAgentName] = useState("");
  const [agentCustomer, setAgentCustomer] = useState("");
  const [agentCustomerBranch, setAgentCustomerBranch] = useState("");
  const [agentOwnOffice, setAgentOwnOffice] = useState("YES");
  const [agentAddressLine1, setAgentAddressLine1] = useState("");
  const [agentAddressLine2, setAgentAddressLine2] = useState("");
  const [agentCity, setAgentCity] = useState("");
  const [agentPincode, setAgentPincode] = useState("");
  const [agentState, setAgentState] = useState("");
  const [agentCountry, setAgentCountry] = useState("");
  const [agentLicenseNumber, setAgentLicenseNumber] = useState("");
  const [agentLicenseNumberSelected, setAgentLicenseNumberSelected] =
    useState(null);
  const [agentExportContactNumber, setAgentExportContactNumber] = useState("");
  const [agentImportContactNumber, setAgentImportContactNumber] = useState("");
  const [agentGstNumber, setAgentGstNumber] = useState("");
  const [agentPanNumber, setAgentPanNumber] = useState("");
  const [agentInvoicing, setAgentInvoicing] = useState("MANDATORY");
  const [agentTaxInvoicePrefix, setAgentTaxInvoicePrefix] = useState("");
  const [agentExpensePrefix, setAgentExpensePrefix] = useState("");
  const [agentCenterPurchaseCount, setAgentCenterPurchaseCount] = useState("");

  // Add field errors
  const [showAgentNameError, setShowAgentNameError] = useState(false);
  const [showAgentCustomerError, setShowAgentCustomerError] = useState(false);
  const [showAgentCustomerBranchError, setShowAgentCustomerBranchError] =
    useState(false);
  const [showAgentAddressLine1Error, setShowAgentAddressLine1Error] =
    useState(false);
  const [showAgentAddressLine2Error, setShowAgentAddressLine2Error] =
    useState(false);
  const [showAgentCityError, setShowAgentCityError] = useState(false);
  const [showAgentPincodeError, setShowAgentPincodeError] = useState(false);
  const [showAgentStateError, setShowAgentStateError] = useState(false);
  const [showAgentCountryError, setShowAgentCountryError] = useState(false);
  const [showAgentLicenseNumberError, setShowAgentLicenseNumberError] =
    useState(false);

  // Add validation summary
  const [showValidationError, setShowValidationError] = useState(false);
  const [validationErrorArray, setValidationErrorArray] = useState([]);
  const [isValidationErrorVisible, setIsValidationErrorVisible] =
    useState(false);

  // ---------- Update form state ----------
  const [updateAgentId, setUpdateAgentId] = useState("");
  const [updateAgentName, setUpdateAgentName] = useState("");
  const [updateAgentCustomer, setUpdateAgentCustomer] = useState("");
  const [updateAgentCustomerBranch, setUpdateAgentCustomerBranch] =
    useState("");
  const [updateAgentOwnOffice, setUpdateAgentOwnOffice] = useState("YES");
  const [updateAgentAddressLine1, setUpdateAgentAddressLine1] = useState("");
  const [updateAgentAddressLine2, setUpdateAgentAddressLine2] = useState("");
  const [updateAgentCity, setUpdateAgentCity] = useState("");
  const [updateAgentPincode, setUpdateAgentPincode] = useState("");
  const [updateAgentState, setUpdateAgentState] = useState("");
  const [updateAgentCountry, setUpdateAgentCountry] = useState("");
  const [updateAgentLicenseNumber, setUpdateAgentLicenseNumber] = useState("");
  const [updateAgentExportContactNumber, setUpdateAgentExportContactNumber] =
    useState("");
  const [updateAgentImportContactNumber, setUpdateAgentImportContactNumber] =
    useState("");
  const [updateAgentGstNumber, setUpdateAgentGstNumber] = useState("");
  const [updateAgentPanNumber, setUpdateAgentPanNumber] = useState("");
  const [updateAgentInvoicing, setUpdateAgentInvoicing] = useState("MANDATORY");
  const [updateAgentTaxInvoicePrefix, setUpdateAgentTaxInvoicePrefix] =
    useState("");
  const [updateAgentExpensePrefix, setUpdateAgentExpensePrefix] = useState("");
  const [updateAgentCenterPurchaseCount, setUpdateAgentCenterPurchaseCount] =
    useState("");

  // Update field errors
  const [showUpdateAgentNameError, setShowUpdateAgentNameError] =
    useState(false);
  const [
    showUpdateAgentAddressLine1Error,
    setShowUpdateAgentAddressLine1Error,
  ] = useState(false);
  const [
    showUpdateAgentAddressLine2Error,
    setShowUpdateAgentAddressLine2Error,
  ] = useState(false);
  const [showUpdateAgentCityError, setShowUpdateAgentCityError] =
    useState(false);
  const [showUpdateAgentPincodeError, setShowUpdateAgentPincodeError] =
    useState(false);
  const [showUpdateAgentStateError, setShowUpdateAgentStateError] =
    useState(false);
  const [
    showUpdateAgentLicenseNumberError,
    setShowUpdateAgentLicenseNumberError,
  ] = useState(false);

  // Update validation summary
  const [showUpdateValidationError, setShowUpdateValidationError] =
    useState(false);
  const [updateValidationErrorArray, setUpdateValidationErrorArray] = useState(
    [],
  );
  const [isUpdateValidationErrorVisible, setIsUpdateValidationErrorVisible] =
    useState(false);

  // ---------- Contact state ----------
  const [agentContacts, setAgentContacts] = useState([]);
  const [contactDataPending, setContactDataPending] = useState(false);
  const [showUpdateContactForm, setShowUpdateContactForm] = useState(false);
  const [deleteAgentContactModal, setDeleteAgentContactModal] = useState(false);

  // Contact add form
  const [contactName, setContactName] = useState("");
  const [contactResponsibility, setContactResponsibility] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactMobile, setContactMobile] = useState("");
  const [contactTelephone, setContactTelephone] = useState("");
  const [contactFax, setContactFax] = useState("");
  const [contactStatus, setContactStatus] = useState("ACTIVE");
  const [contactDefault, setContactDefault] = useState("NO");

  // Contact add errors
  const [contactNameError, setContactNameError] = useState(false);
  const [contactResponsibilityError, setContactResponsibilityError] =
    useState(false);
  const [contactEmailError, setContactEmailError] = useState(false);
  const [contactMobileError, setContactMobileError] = useState(false);

  // Contact add validation summary
  const [contactValidationError, setContactValidationError] = useState(false);
  const [contactValidationErrorArray, setContactValidationErrorArray] =
    useState([]);
  const [contactValidationErrorVisible, setContactValidationErrorVisible] =
    useState(false);

  // Contact update form
  const [updateContactSerialNumber, setUpdateContactSerialNumber] =
    useState("");
  const [updateContactName, setUpdateContactName] = useState("");
  const [updateContactResponsibility, setUpdateContactResponsibility] =
    useState("");
  const [updateContactEmail, setUpdateContactEmail] = useState("");
  const [updateContactMobile, setUpdateContactMobile] = useState("");
  const [updateContactTelephone, setUpdateContactTelephone] = useState("");
  const [updateContactFax, setUpdateContactFax] = useState("");
  const [updateContactStatus, setUpdateContactStatus] = useState("ACTIVE");
  const [updateContactDefault, setUpdateContactDefault] = useState("NO");

  // Contact update errors
  const [updateContactNameError, setUpdateContactNameError] = useState(false);
  const [
    updateContactResponsibilityError,
    setUpdateContactResponsibilityError,
  ] = useState(false);
  const [updateContactEmailError, setUpdateContactEmailError] = useState(false);
  const [updateContactMobileError, setUpdateContactMobileError] =
    useState(false);

  // Contact update validation summary
  const [contactUpdateValidationError, setContactUpdateValidationError] =
    useState(false);
  const [
    contactUpdateValidationErrorArray,
    setContactUpdateValidationErrorArray,
  ] = useState([]);
  const [
    contactUpdateValidationErrorVisible,
    setContactUpdateValidationErrorVisible,
  ] = useState(false);

  // ---------- Uploads state ----------
  const [updateAgentUploadFiles, setUpdateAgentUploadFiles] = useState([]);
  const [updateAgentUploadFileNames, setUpdateAgentUploadFileNames] = useState(
    [],
  );
  const [agentUploads, setAgentUploads] = useState([]);

  const [deleteAgentUploadModal, setDeleteAgentUploadModal] = useState(false);
  const [uploadAgentFilesSerialNumber, setUploadAgentFilesSerialNumber] =
    useState("");
  const [deleteAgentUploadFileName, setDeleteAgentUploadFileName] =
    useState("");

  // License number uniqueness check
  const [agentLicenseNumberExist, setAgentLicenseNumberExist] = useState(false);
  const [agentLicenseNumberList, setAgentLicenseNumberList] = useState([]);

  const user_role = sessionStorage["userrole"];
  const user_id = sessionStorage["id"];

  // ========== Validation Helpers ==========
  const isNumeric = (val) => /^\d+$/.test(val);
  //   const isAlphanumeric = (val) => /^[a-zA-Z0-9]+$/.test(val);
  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  // ========== Real‑time error helpers for Add ==========
  const hasAnyAddError = () => {
    return (
      showAgentNameError ||
      showAgentCustomerError ||
      showAgentCustomerBranchError ||
      showAgentAddressLine1Error ||
      showAgentAddressLine2Error ||
      showAgentCityError ||
      showAgentPincodeError ||
      showAgentStateError ||
      showAgentCountryError ||
      showAgentLicenseNumberError
    );
  };

  const buildAddErrorMessages = () => {
    const errors = [];
    if (!agentName) errors.push("Agent name is required");
    if (!agentCustomer) errors.push("Customer is required");
    if (!agentCustomerBranch) errors.push("Branch is required");
    if (!agentAddressLine1) errors.push("Address Line 1 is required");
    if (!agentAddressLine2) errors.push("Address Line 2 is required");
    if (!agentCity) errors.push("City is required");
    if (!agentPincode) errors.push("Pincode is required");
    else if (!isNumeric(agentPincode))
      errors.push("Pincode must contain only digits");
    if (!agentState) errors.push("State is required");
    if (!agentCountry) errors.push("Country is required");
    if (!agentLicenseNumber) errors.push("License number is required");
    return errors;
  };

  // ========== Real‑time error helpers for Update ==========
  const hasAnyUpdateError = () => {
    return (
      showUpdateAgentNameError ||
      showUpdateAgentAddressLine1Error ||
      showUpdateAgentAddressLine2Error ||
      showUpdateAgentCityError ||
      showUpdateAgentPincodeError ||
      showUpdateAgentStateError ||
      showUpdateAgentLicenseNumberError
    );
  };

  const buildUpdateErrorMessages = () => {
    const errors = [];
    if (!updateAgentName) errors.push("Agent name is required");
    if (!updateAgentAddressLine1) errors.push("Address Line 1 is required");
    if (!updateAgentAddressLine2) errors.push("Address Line 2 is required");
    if (!updateAgentCity) errors.push("City is required");
    if (!updateAgentPincode) errors.push("Pincode is required");
    else if (!isNumeric(updateAgentPincode))
      errors.push("Pincode must contain only digits");
    if (!updateAgentState) errors.push("State is required");
    if (!updateAgentLicenseNumber) errors.push("License number is required");
    return errors;
  };

  // ========== Contact validation helpers ==========
  const hasAnyContactError = () => {
    return (
      contactNameError ||
      contactResponsibilityError ||
      contactEmailError ||
      contactMobileError
    );
  };

  const buildContactErrorMessages = () => {
    const errors = [];
    if (!contactName) errors.push("Name is required");
    if (!contactResponsibility) errors.push("Responsibility is required");
    if (!contactEmail) errors.push("Email is required");
    else if (!validateEmail(contactEmail)) errors.push("Email must be valid");
    if (!contactMobile) errors.push("Mobile number is required");
    else if (!isNumeric(contactMobile))
      errors.push("Mobile number must contain only digits");
    return errors;
  };

  const hasAnyUpdateContactError = () => {
    return (
      updateContactNameError ||
      updateContactResponsibilityError ||
      updateContactEmailError ||
      updateContactMobileError
    );
  };

  const buildUpdateContactErrorMessages = () => {
    const errors = [];
    if (!updateContactName) errors.push("Name is required");
    if (!updateContactResponsibility) errors.push("Responsibility is required");
    if (!updateContactEmail) errors.push("Email is required");
    else if (!validateEmail(updateContactEmail))
      errors.push("Email must be valid");
    if (!updateContactMobile) errors.push("Mobile number is required");
    else if (!isNumeric(updateContactMobile))
      errors.push("Mobile number must contain only digits");
    return errors;
  };

  // Tooltip toggles
  const handleCheckValidationClick = () =>
    setIsValidationErrorVisible(!isValidationErrorVisible);
  const handleUpdateCheckValidationClick = () =>
    setIsUpdateValidationErrorVisible(!isUpdateValidationErrorVisible);

  // ========== API calls ==========
  const getLoggedInUser = useCallback(async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/user/" + user_id,
      );
      setLoggedInUser(response.data);
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  }, [user_id]);

  const getAgent = async () => {
    try {
      setDataPending(true);
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/agent/",
      );
      setData(response.data);
      const license_number_list = response.data
        ?.filter((item) => item.license_number)
        .map((item) => ({
          value: item.license_number,
          label: item.license_number,
        }));
      setAgentLicenseNumberList(license_number_list);
    } catch (err) {
      toast.error("Error in fetching agent data! Try again.");
    } finally {
      setDataPending(false);
    }
  };

  const getCountry = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/country/",
      );
      const sorted_data = response.data.sort(
        (a, b) => a.object_id - b.object_id,
      );
      setCountryData(sorted_data);
    } catch (err) {
      toast.error("Error in fetching country data! Try again.");
    }
  };

  const getCustomer = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/customer/",
      );
      setCustomerData(response.data);
    } catch (err) {
      toast.error("Error in fetching customer data! Try again.");
    }
  };

  const getCustomerBranch = async (customer) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/customerbranch?customer=" +
          customer,
      );
      setCustomerBranchData(response.data);
    } catch (err) {
      toast.error("Error in fetching customer branch data! Try again.");
    }
  };

  const getAgentUser = async (id) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/agent/getagentuser?agent=" +
          id,
      );
      setAgentUserData(response.data);
    } catch (err) {
      toast.error("Error in fetching agent user data! Try again.");
    }
  };

  const getAgentTariff = async (agent) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/master/tariffcharge?agent=" +
          agent,
      );
      setAgentTariffData(response.data);
    } catch (err) {
      toast.error("Error in fetching tariff data! Try again.");
    }
  };

  const getCurrentUserRolePermission = async (roles) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/role/getuserrolepermission?roles=" +
          roles,
      );
      const role_permissions_array = [];
      for (let i = 0; i < response.data.length; i++) {
        for (let j = 0; j < response?.data[i]?.permissions_array.length; j++) {
          if (
            !role_permissions_array.includes(
              response?.data[i]?.permissions_array?.[j],
            )
          ) {
            role_permissions_array.push(
              response?.data[i]?.permissions_array?.[j],
            );
          }
        }
      }
      setCurrentUserRolePermissionData(role_permissions_array);
    } catch (err) {
      toast.error("Error in fetching user role data! Try again.");
    }
  };

  useEffect(() => {
    getLoggedInUser();
    getAgent();
    getCountry();
    getCustomer();
  }, [getLoggedInUser]);

  useEffect(() => {
    getCurrentUserRolePermission(user_role);
  }, [user_role]);

  // ========== Delete handlers (Agent) ==========
  const handleDeleteModalClose = () => setShowDeleteModal(false);
  const handleDeleteModalOpen = (data) => {
    setShowDeleteModal(true);
    setAgentForDelete(data?.id);
  };

  const handleDeleteAgent = async () => {
    setShowDeleteAgentLoader(true);
    try {
      await axios.delete(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/agent/" +
          agentForDelete +
          "/",
        {
          headers: { "content-type": "application/json" },
        },
      );
      toast.success("Agent deleted Successfully");
      getAgent();
      handleDeleteModalClose();
    } catch (err) {
      toast.error("Error deleting agent! Try again.");
    } finally {
      setShowDeleteAgentLoader(false);
    }
  };

  // ========== Add logic ==========
  const resetAddForm = () => {
    setAgentName("");
    setAgentCustomer("");
    setAgentCustomerBranch("");
    setAgentOwnOffice("YES");
    setAgentAddressLine1("");
    setAgentAddressLine2("");
    setAgentCity("");
    setAgentPincode("");
    setAgentState("");
    setAgentCountry("");
    setAgentLicenseNumber("");
    setAgentLicenseNumberSelected(null);
    setAgentExportContactNumber("");
    setAgentImportContactNumber("");
    setAgentGstNumber("");
    setAgentPanNumber("");
    setAgentInvoicing("MANDATORY");
    setAgentTaxInvoicePrefix("");
    setAgentExpensePrefix("");
    setAgentCenterPurchaseCount("");
    setShowAgentNameError(false);
    setShowAgentCustomerError(false);
    setShowAgentCustomerBranchError(false);
    setShowAgentAddressLine1Error(false);
    setShowAgentAddressLine2Error(false);
    setShowAgentCityError(false);
    setShowAgentPincodeError(false);
    setShowAgentStateError(false);
    setShowAgentCountryError(false);
    setShowAgentLicenseNumberError(false);
    setShowValidationError(false);
    setValidationErrorArray([]);
    setIsValidationErrorVisible(false);
    setActiveStep(0);
  };

  const handleAddModalClose = () => {
    resetAddForm();
    setShowAddCanvas(false);
    setCanvasAddFullScreen(false);
  };

  const addAgent = async (e) => {
    e.preventDefault();

    setShowAgentNameError(!agentName);
    setShowAgentCustomerError(!agentCustomer);
    setShowAgentCustomerBranchError(!agentCustomerBranch);
    setShowAgentAddressLine1Error(!agentAddressLine1);
    setShowAgentAddressLine2Error(!agentAddressLine2);
    setShowAgentCityError(!agentCity);
    setShowAgentPincodeError(!agentPincode || !isNumeric(agentPincode));
    setShowAgentStateError(!agentState);
    setShowAgentCountryError(!agentCountry);
    setShowAgentLicenseNumberError(!agentLicenseNumber);
    setValidationErrorArray(buildAddErrorMessages());

    if (
      !agentName ||
      !agentCustomer ||
      !agentCustomerBranch ||
      !agentAddressLine1 ||
      !agentAddressLine2 ||
      !agentCity ||
      !agentPincode ||
      !agentState ||
      !agentCountry ||
      !agentLicenseNumber ||
      !isNumeric(agentPincode)
    ) {
      setShowValidationError(true);
      return;
    }

    setShowAddLoader(true);

    const payload = {
      name: agentName,
      customer_branch: agentCustomerBranch,
      own_office: agentOwnOffice,
      address_line_1: agentAddressLine1,
      address_line_2: agentAddressLine2,
      city: agentCity,
      pincode: agentPincode,
      country: agentCountry,
      state: agentState,
      license_number: agentLicenseNumber,
      export_contact_number: agentExportContactNumber || "",
      import_contact_number: agentImportContactNumber || "",
      gst_number: agentGstNumber || "",
      pan_number: agentPanNumber || "",
      invoicing: agentInvoicing,
      tax_invoice_prefix: agentTaxInvoicePrefix || "",
      expense_prefix: agentExpensePrefix || "",
      center_purchase_count: agentCenterPurchaseCount || "",
      created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    try {
      const response = await axios.post(
        process.env.REACT_APP_BACKEND_API_URL + "/user/agent/",
        payload,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 201) {
        toast.success("Agent Added Successfully");
        handleAddModalClose();
        getAgent();
      }
    } catch (err) {
      toast.error("Error creating agent");
    } finally {
      setShowAddLoader(false);
    }
  };

  // ========== Update logic ==========
  const resetUpdateForm = () => {
    setUpdateAgentId("");
    setUpdateAgentName("");
    setUpdateAgentCustomer("");
    setUpdateAgentCustomerBranch("");
    setUpdateAgentOwnOffice("YES");
    setUpdateAgentAddressLine1("");
    setUpdateAgentAddressLine2("");
    setUpdateAgentCity("");
    setUpdateAgentPincode("");
    setUpdateAgentState("");
    setUpdateAgentCountry("");
    setUpdateAgentLicenseNumber("");
    setUpdateAgentExportContactNumber("");
    setUpdateAgentImportContactNumber("");
    setUpdateAgentGstNumber("");
    setUpdateAgentPanNumber("");
    setUpdateAgentInvoicing("MANDATORY");
    setUpdateAgentTaxInvoicePrefix("");
    setUpdateAgentExpensePrefix("");
    setUpdateAgentCenterPurchaseCount("");
    setShowUpdateAgentNameError(false);
    setShowUpdateAgentAddressLine1Error(false);
    setShowUpdateAgentAddressLine2Error(false);
    setShowUpdateAgentCityError(false);
    setShowUpdateAgentPincodeError(false);
    setShowUpdateAgentStateError(false);
    setShowUpdateAgentLicenseNumberError(false);
    setShowUpdateValidationError(false);
    setUpdateValidationErrorArray([]);
    setIsUpdateValidationErrorVisible(false);
    setAgentUploads([]);
    setAgentUserData([]);
    setAgentTariffData([]);
    setAgentContacts([]);
    setShowUpdateAgentDetails(true);
    setShowUpdateAgentContactDetails(false);
    setShowUpdateAgentUploadsDetails(false);
    setShowUpdateAgentUserDetails(false);
    setShowUpdateAgentTariffDetails(false);
    setActiveStep(0);
  };

  const handleUpdateModalClose = () => {
    resetUpdateForm();
    setShowUpdateCanvas(false);
    setCanvasUpdateFullScreen(false);
  };

  const setRecordForUpdatePanel = (row) => {
    setUpdateAgentId(row.id);
    setUpdateAgentName(row.name);
    setUpdateAgentOwnOffice(row.own_office);
    setUpdateAgentAddressLine1(row.address_line_1);
    setUpdateAgentAddressLine2(row.address_line_2);
    setUpdateAgentCity(row.city);
    setUpdateAgentPincode(row.pincode);
    setUpdateAgentState(row.state);
    setUpdateAgentCountry(row.country);
    setUpdateAgentLicenseNumber(row.license_number);
    setUpdateAgentExportContactNumber(row.export_contact_number || "");
    setUpdateAgentImportContactNumber(row.import_contact_number || "");
    setUpdateAgentGstNumber(row.gst_number || "");
    setUpdateAgentPanNumber(row.pan_number || "");
    setUpdateAgentInvoicing(row.invoicing);
    setUpdateAgentTaxInvoicePrefix(row.tax_invoice_prefix || "");
    setUpdateAgentExpensePrefix(row.expense_prefix || "");
    setUpdateAgentCenterPurchaseCount(row.center_purchase_count || "");

    setUpdateAgentCustomer(row.customer_branch_data?.customer);
    getCustomerBranch(row.customer_branch_data?.customer);
    setUpdateAgentCustomerBranch(row.customer_branch);

    setAgentUploads(row.upload_urls || []);
    getAgentUser(row.id);
    setAgentContacts(row.contacts || []);
    getAgentTariff(row.id);
    setContactDataPending(false);
    setShowUpdateAgentDetails(true);
    setShowUpdateAgentContactDetails(false);
    setShowUpdateAgentUploadsDetails(false);
    setShowUpdateAgentUserDetails(false);
    setShowUpdateAgentTariffDetails(false);
    setActiveStep(0);
  };

  const updateAgent = async (e) => {
    e.preventDefault();

    setShowUpdateAgentNameError(!updateAgentName);
    setShowUpdateAgentAddressLine1Error(!updateAgentAddressLine1);
    setShowUpdateAgentAddressLine2Error(!updateAgentAddressLine2);
    setShowUpdateAgentCityError(!updateAgentCity);
    setShowUpdateAgentPincodeError(
      !updateAgentPincode || !isNumeric(updateAgentPincode),
    );
    setShowUpdateAgentStateError(!updateAgentState);
    setShowUpdateAgentLicenseNumberError(!updateAgentLicenseNumber);
    setUpdateValidationErrorArray(buildUpdateErrorMessages());

    if (
      !updateAgentName ||
      !updateAgentAddressLine1 ||
      !updateAgentAddressLine2 ||
      !updateAgentCity ||
      !updateAgentPincode ||
      !updateAgentState ||
      !updateAgentLicenseNumber ||
      !isNumeric(updateAgentPincode)
    ) {
      setShowUpdateValidationError(true);
      return;
    }

    setShowUpdateLoader(true);

    const payload = {
      name: updateAgentName,
      customer_branch: updateAgentCustomerBranch || [],
      own_office: updateAgentOwnOffice,
      address_line_1: updateAgentAddressLine1,
      address_line_2: updateAgentAddressLine2,
      city: updateAgentCity,
      pincode: updateAgentPincode,
      country: updateAgentCountry,
      state: updateAgentState,
      license_number: updateAgentLicenseNumber,
      export_contact_number: updateAgentExportContactNumber || "",
      import_contact_number: updateAgentImportContactNumber || "",
      gst_number: updateAgentGstNumber || "",
      pan_number: updateAgentPanNumber || "",
      invoicing: updateAgentInvoicing,
      tax_invoice_prefix: updateAgentTaxInvoicePrefix || "",
      expense_prefix: updateAgentExpensePrefix || "",
      center_purchase_count: updateAgentCenterPurchaseCount || "",
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/agent/" +
          updateAgentId +
          "/",
        payload,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200) {
        toast.success("Agent updated Successfully");
        handleUpdateModalClose();
        getAgent();
      }
    } catch (err) {
      toast.error("Error updating agent");
    } finally {
      setShowUpdateLoader(false);
    }
  };

  // ========== Contact logic ==========
  const resetContactForm = () => {
    setContactName("");
    setContactResponsibility("");
    setContactEmail("");
    setContactMobile("");
    setContactTelephone("");
    setContactFax("");
    setContactStatus("ACTIVE");
    setContactDefault("NO");
    setContactNameError(false);
    setContactResponsibilityError(false);
    setContactEmailError(false);
    setContactMobileError(false);
    setContactValidationError(false);
    setContactValidationErrorArray([]);
  };

  const addAgentContact = async (e) => {
    e.preventDefault();

    setContactNameError(!contactName);
    setContactResponsibilityError(!contactResponsibility);
    setContactEmailError(!contactEmail || !validateEmail(contactEmail));
    setContactMobileError(!contactMobile || !isNumeric(contactMobile));
    setContactValidationErrorArray(buildContactErrorMessages());

    if (
      !contactName ||
      !contactResponsibility ||
      !contactEmail ||
      !contactMobile ||
      !validateEmail(contactEmail) ||
      !isNumeric(contactMobile)
    ) {
      setContactValidationError(true);
      return;
    }

    setShowAddAgentContactLoader(true);

    const data = {
      id: updateAgentId,
      name: contactName,
      responsibility: contactResponsibility,
      email: contactEmail,
      mobile: contactMobile,
      telephone: contactTelephone || "",
      fax: contactFax || "",
      is_default: contactDefault,
      status: contactStatus,
    };

    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL + "/user/agent/addnewcontact/",
        data,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200) {
        toast.success("Contact Added Successfully");
        setAgentContacts(response?.data?.contacts);
        resetContactForm();
      }
    } catch (err) {
      toast.error("Error adding contact");
    } finally {
      setShowAddAgentContactLoader(false);
    }
  };

  const setUpdateContactDetails = (row) => {
    setShowUpdateContactForm(true);
    setUpdateContactSerialNumber(row.serial_number);
    setUpdateContactName(row.name);
    setUpdateContactResponsibility(row.responsibility);
    setUpdateContactEmail(row.email);
    setUpdateContactMobile(row.mobile);
    setUpdateContactTelephone(row.telephone || "");
    setUpdateContactFax(row.fax || "");
    setUpdateContactStatus(row.status);
    setUpdateContactDefault(row.is_default);
    // Reset errors
    setUpdateContactNameError(false);
    setUpdateContactResponsibilityError(false);
    setUpdateContactEmailError(false);
    setUpdateContactMobileError(false);
    setContactUpdateValidationError(false);
    setContactUpdateValidationErrorArray([]);
  };

  const updateAgentContact = async (e) => {
    e.preventDefault();

    setUpdateContactNameError(!updateContactName);
    setUpdateContactResponsibilityError(!updateContactResponsibility);
    setUpdateContactEmailError(
      !updateContactEmail || !validateEmail(updateContactEmail),
    );
    setUpdateContactMobileError(
      !updateContactMobile || !isNumeric(updateContactMobile),
    );
    setContactUpdateValidationErrorArray(buildUpdateContactErrorMessages());

    if (
      !updateContactName ||
      !updateContactResponsibility ||
      !updateContactEmail ||
      !updateContactMobile ||
      !validateEmail(updateContactEmail) ||
      !isNumeric(updateContactMobile)
    ) {
      setContactUpdateValidationError(true);
      return;
    }

    setShowUpdateAgentContactLoader(true);

    const data = {
      id: updateAgentId,
      serial_number: updateContactSerialNumber,
      name: updateContactName,
      responsibility: updateContactResponsibility,
      email: updateContactEmail,
      mobile: updateContactMobile,
      telephone: updateContactTelephone || "",
      fax: updateContactFax || "",
      is_default: updateContactDefault,
      status: updateContactStatus,
    };

    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL + "/user/agent/updatecontact/",
        data,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200) {
        toast.success("Contact Updated Successfully");
        setAgentContacts(response?.data?.contacts);
        setShowUpdateContactForm(false);

        setUpdateContactSerialNumber("");
        setUpdateContactName("");
        setUpdateContactResponsibility("");
        setUpdateContactEmail("");
        setUpdateContactMobile("");
        setUpdateContactTelephone("");
        setUpdateContactFax("");
        setUpdateContactDefault("NO");
        setUpdateContactStatus("ACTIVE");
      }
    } catch (err) {
      toast.error("Error updating contact");
    } finally {
      setShowUpdateAgentContactLoader(false);
    }
  };

  const setDeleteContactDetails = (row) => {
    setDeleteAgentContactModal(true);
    setUpdateContactSerialNumber(row.serial_number);
    setUpdateContactName(row.name);
  };

  const deleteAgentContact = async () => {
    setShowDeleteAgentContactLoader(true);
    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL + "/user/agent/deletecontact/",
        { id: updateAgentId, serial_number: updateContactSerialNumber },
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200) {
        toast.success("Contact Deleted Successfully");
        setAgentContacts(response?.data?.contacts);
        setDeleteAgentContactModal(false);
      }
    } catch (err) {
      toast.error("Error deleting contact");
    } finally {
      setShowDeleteAgentContactLoader(false);
    }
  };

  // ========== Uploads logic ==========
  const handleUpdateAgentUploadsFileChange = (files) => {
    const fileArray = Array.from(files);
    const names = fileArray.map((file) => file.name);
    setUpdateAgentUploadFileNames(names);
    setUpdateAgentUploadFiles(files);
  };

  const updateAgentUploads = async (e) => {
    e.preventDefault();
    if (updateAgentUploadFiles.length === 0) return;

    setShowAgentUploadFilesLoader(true);
    const formData = new FormData();
    formData.append("id", updateAgentId);
    for (let i = 0; i < updateAgentUploadFiles.length; i++) {
      formData.append("upload", updateAgentUploadFiles[i]);
    }
    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL + "/user/agent/agentuploads/",
        formData,
        { headers: { "content-type": "multipart/form-data" } },
      );
      if (response.status === 200) {
        toast.success("Files Uploaded Successfully");
        setAgentUploads(response.data.upload_urls);
        setUpdateAgentUploadFiles([]);
        setUpdateAgentUploadFileNames([]);
        document.getElementById("update_agent_uploads").value = "";
      }
    } catch (err) {
      toast.error("Error uploading files");
    } finally {
      setShowAgentUploadFilesLoader(false);
    }
  };

  const setDeleteUploadDetails = (row) => {
    setDeleteAgentUploadModal(true);
    setUploadAgentFilesSerialNumber(row.serial_number);
    setDeleteAgentUploadFileName(row.filename);
  };

  const deleteAgentUploads = async () => {
    setShowDeleteAgentUploadFilesLoader(true);
    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/agent/deleteagentuploads/",
        { id: updateAgentId, serial_number: uploadAgentFilesSerialNumber },
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200) {
        toast.success("File Deleted Successfully");
        setAgentUploads(response.data.upload_urls);
      }
    } catch (err) {
      toast.error("Error deleting file");
    } finally {
      setShowDeleteAgentUploadFilesLoader(false);
      setDeleteAgentUploadModal(false);
    }
  };

  // ========== Table columns ==========
  const columns = [
    { name: "Name", selector: (row) => row.name, sortable: true },
    {
      name: "Customer",
      selector: (row) => row.customer_branch_data?.customer_data?.name,
      sortable: true,
    },
    {
      name: "Location",
      selector: (row) => row.customer_branch_data?.port_data?.name,
      sortable: true,
    },
    {
      name: "Address",
      width: "600px",
      selector: (row) =>
        `${row.address_line_1}, ${row.address_line_2}, ${row.city}, ${row.state}, ${row.pincode}`,
      sortable: true,
    },
    { name: "Own Office", selector: (row) => row.own_office, sortable: true },
    {
      name: "Country",
      center: true,
      selector: (row) => (
        <div className="text-center">
          <img
            src={row.country_data?.image_url}
            height={20}
            width={35}
            style={{ marginBottom: 5 }}
            alt="flag"
          />
          <br />
          <span>{row.country_data?.long_name}</span>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Action",
      center: true,
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes("master:agent:update") && (
            <Button
              className="btn btn-sm btn-inox-green border-0"
              title="Update"
              onClick={() => {
                setRecordForUpdatePanel(row);
                setShowUpdateCanvas(true);
              }}
            >
              <i className="fa fa-edit"></i>
            </Button>
          )}
          {currentUserRolePermissionData?.includes("master:agent:delete") && (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => handleDeleteModalOpen(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          )}
        </div>
      ),
    },
  ];

  const contactcolumns = [
    { name: "Name", selector: (row) => row.name, sortable: true },
    {
      name: "Responsibility",
      selector: (row) => row.responsibility.replaceAll("_", " "),
      sortable: true,
    },
    { name: "Email", selector: (row) => row.email, sortable: true },
    { name: "Mobile Number", selector: (row) => row.mobile, sortable: true },
    {
      name: "Telephone Number",
      selector: (row) => row.telephone,
      sortable: true,
    },
    { name: "Fax Number", selector: (row) => row.fax, sortable: true },
    { name: "Default", selector: (row) => row.is_default, sortable: true },
    { name: "Status", selector: (row) => row.status, sortable: true },
    {
      name: "Action",
      center: true,
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes("master:agent:update") && (
            <Button
              className="btn btn-sm btn-inox-green border-0"
              title="Update"
              onClick={() => setUpdateContactDetails(row)}
            >
              <i className="fa fa-edit"></i>
            </Button>
          )}
          {currentUserRolePermissionData?.includes("master:agent:delete") && (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => setDeleteContactDetails(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          )}
        </div>
      ),
    },
  ];

  const agentusercolumns = [
    {
      name: "Profile",
      width: "100px",
      selector: (row) => (
        <div className="text-center">
          {row.picture ? (
            <img
              src={`${process.env.REACT_APP_BACKEND_API_URL}${row.picture}`}
              className="img img-thumbnail"
              style={{ height: 50, width: 50 }}
              alt="profile"
            />
          ) : (
            <img
              src={PlaceholderPicture}
              className="img img-thumbnail border"
              height={50}
              width={50}
              alt="placeholder"
            />
          )}
        </div>
      ),
    },
    { name: "Name", selector: (row) => row.name, sortable: true },
    { name: "Username", selector: (row) => row.username, sortable: true },
    { name: "Email", selector: (row) => row.email, sortable: true },
    { name: "Contact", selector: (row) => row.mobile, sortable: true },
    { name: "Is Employee", selector: (row) => row.is_employee, sortable: true },
    {
      name: "Action",
      center: true,
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes("master:agent:delete") && (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => handleDeleteModalOpen(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          )}
        </div>
      ),
    },
  ];

  const agenttariffcolumns = [
    {
      name: "Service Provider",
      width: "200px",
      selector: (row) => (
        <div className="text-left">
          <span>
            <b>Agent:</b> {row.agent_data?.name}
          </span>
          <br />
          <span>
            <b>Vendor:</b> {row.vendor_data?.name}
          </span>
        </div>
      ),
    },
    {
      name: "Charge Details",
      width: "300px",
      selector: (row) => (
        <div className="text-left">
          <span>
            <b>Charge Name: </b>
            {row.charge_name}
          </span>
          <br />
          <span>
            <b>Product: </b>
            {row.product_data?.product_name}
          </span>
          <br />
          <span>
            <b>Charge Type: </b>
            <span
              className={row.charge_type === "HAZARDOUS" ? "text-danger" : ""}
            >
              {row.charge_type.replaceAll("_", " ")}
            </span>
          </span>
          <br />
          <span>
            <b>Charge Category: </b>
            {row.charge_category.replaceAll("_", " ")}
          </span>
          <br />
          <span>
            <b>Charge Basis: </b>
            {row.charge_basis.replaceAll("_", " ")}
          </span>
        </div>
      ),
    },
    {
      name: "Amount and Expense",
      width: "180px",
      selector: (row) => (
        <div className="text-left">
          <span>
            <b>Amount:</b> {row.currency_data?.symbol} {row.amount}
          </span>
          <br />
          <span>
            <b>Amount Type:</b> {row.amount_type}
          </span>
          <br />
          <span>
            <b>Expense:</b> {row.currency_data?.symbol} {row.expense}
          </span>
        </div>
      ),
    },
    { name: "Port", width: "250px", selector: (row) => row.port_data?.name },
    {
      name: "Applicable For",
      width: "150px",
      selector: (row) => row.applicable_for,
    },
    {
      name: "Validity",
      width: "200px",
      selector: (row) => (
        <div className="text-left">
          <span>
            <b>Valid From:</b> {format(new Date(row.valid_from), "dd/MM/yyyy")}
          </span>
          <br />
          <span>
            <b>Valid To:</b> {format(new Date(row.valid_to), "dd/MM/yyyy")}
          </span>
        </div>
      ),
    },
    {
      name: "Other",
      width: "300px",
      selector: (row) => (
        <div className="text-left">
          <span>
            <b>Is Mandatory:</b> {row.is_mandatory_charge ? "YES" : "NO"}
          </span>
          <br />
          <span>
            <b>Is Terminal Specific:</b>{" "}
            {row.is_terminal_specific_charge ? "YES" : "NO"}
          </span>
          <br />
          <span>
            <b>Terminal:</b> {row.terminal_data?.name}
          </span>
          <br />
          <span>
            <b>Event Type:</b> {row.event_type.replaceAll("_", " ")}
          </span>
          <br />
          <span>
            <b>Event Sub-Type:</b> {row.event_sub_type.replaceAll("_", " ")}
          </span>
        </div>
      ),
    },
    { name: "Payable By", width: "120px", selector: (row) => row.payable_by },
  ];

  const agentuploadcolumns = [
    { name: "File Name", selector: (row) => row.filename, sortable: true },
    {
      name: "Preview",
      selector: (row) => (
        <img
          className="img img-thumbnail"
          src={`${process.env.REACT_APP_BACKEND_API_URL}${row.file_url}`}
          height={40}
          width={40}
          alt="preview"
        />
      ),
    },
    { name: "File Type", selector: (row) => row.filetype, sortable: true },
    {
      name: "File Size",
      selector: (row) => `${row.filesize} ${row.fileunit}`,
      sortable: true,
    },
    {
      name: "Action",
      center: true,
      selector: (row) => (
        <div>
          <a
            href={`${process.env.REACT_APP_BACKEND_API_URL}${row.file_url}`}
            target="_blank"
            rel="noopener noreferrer"
            title="View"
          >
            <Button className="btn btn-sm btn-inox-green border-0 mx-2">
              <i className="fa fa-eye"></i>
            </Button>
          </a>
          {currentUserRolePermissionData?.includes("master:agent:delete") && (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => setDeleteUploadDetails(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          )}
        </div>
      ),
    },
  ];

  const customComponents = {
    DropdownIndicator: () => null,
    IndicatorSeparator: () => null,
  };

  const handleDataFromTopNavBar = (permissiondata) =>
    setDataFromTopNavBar(permissiondata);

  return (
    <div className="page-content-bg">
      <ToastContainer />
      <TopNavbar
        sidebarCollapsed={menuDrawerShow}
        topNavbarStatic={true}
        sendDataToParent={handleDataFromTopNavBar}
      />
      <SideNavbar
        sidebarCollapsed={menuDrawerShow}
        activeMenu="Master"
        activeSubMenu="AdminMaster"
        activeSubMenuLevel1="AgentMaster"
        permissionFromTopNavbar={dataFromTopNavBar}
      />

      <div
        className={
          menuDrawerShow
            ? "row main-content-collapsed text-left py-0"
            : "row main-content text-left py-0"
        }
      >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-6 py-1">
              <Button
                className="btn btn-sm btn-inox-green border-0 mx-2"
                onClick={() => setMenuDrawerShow(!menuDrawerShow)}
              >
                {menuDrawerShow ? (
                  <span>
                    <i className="fa fa-chevron-left mx-1"></i>
                  </span>
                ) : (
                  <span>
                    <i className="fa fa-chevron-right mx-1"></i>
                  </span>
                )}
              </Button>
              <span className="page-header-text">Agent Master</span>
            </div>
            <div className="col-6 py-1" style={{ paddingRight: 30 }}>
              {currentUserRolePermissionData?.includes("master:agent:add") && (
                <Button
                  className="btn btn-sm btn-inox-green border-0 px-3 float-right"
                  onClick={() => {
                    resetAddForm();
                    setShowAddCanvas(true);
                  }}
                >
                  <i
                    className="fa fa-plus fa-lg text-right"
                    style={{ paddingRight: 10 }}
                  ></i>
                  <span className="fw-bold">Add Agent</span>
                </Button>
              )}
            </div>
          </div>
        </div>

        <div
          className="col-12 text-left"
          style={{
            marginTop: -5,
            paddingLeft: 20,
            paddingRight: 30,
            zIndex: 100,
          }}
        >
          <DataTable
            columns={columns}
            data={data}
            progressPending={dataPending}
            progressComponent={
              <Spinner
                className="mx-5 text-inox-green table-spinner"
                as="span"
                animation="border"
                size="lg"
                role="status"
                aria-hidden="true"
              />
            }
            noDataComponent={
              <p className="text-center table-no-data">No Data Found</p>
            }
            pagination
            highlightOnHover
            fixedHeader
            customStyles={userTableCustomStyles}
            dense
          />
        </div>
      </div>

      {/* Delete Modal */}
      <Modal
        size="sm"
        show={showDeleteModal}
        onHide={handleDeleteModalClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>
            Close
          </Button>
          <Button variant="danger" onClick={handleDeleteAgent}>
            {showDeleteAgentLoader ? (
              <Spinner
                className="mx-3 text-white"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------------------------ Update Canvas ------------------- */}
      <div
        className={
          canvasUpdateFullScreen && showUpdateCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasUpdateFullScreen && showUpdateCanvas
              ? "offcanvas offcanvas-bottom h-50 show"
              : "offcanvas offcanvas-bottom h-50"
        }
        tabIndex="-1"
        aria-labelledby="updateCanvasLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-8">
              <h4 id="updateCanvasLabel" className="float-left px-3">
                Update Record{" "}
                <span className="font-14px">( {updateAgentName} )</span>
              </h4>
              <Button
                className={`${showUpdateAgentDetails ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                style={{ marginRight: 10, width: 120 }}
                onClick={() => {
                  setShowUpdateAgentDetails(true);
                  setShowUpdateAgentContactDetails(false);
                  setShowUpdateAgentUploadsDetails(false);
                  setShowUpdateAgentUserDetails(false);
                  setShowUpdateAgentTariffDetails(false);
                }}
              >
                Details
              </Button>
              <Button
                className={`${showUpdateAgentContactDetails ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                style={{ marginRight: 10, width: 120 }}
                onClick={() => {
                  setShowUpdateAgentDetails(false);
                  setShowUpdateAgentContactDetails(true);
                  setShowUpdateAgentUploadsDetails(false);
                  setShowUpdateAgentUserDetails(false);
                  setShowUpdateAgentTariffDetails(false);
                }}
              >
                Contacts
              </Button>
              <Button
                className={`${showUpdateAgentUploadsDetails ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                style={{ marginRight: 10, width: 120 }}
                onClick={() => {
                  setShowUpdateAgentDetails(false);
                  setShowUpdateAgentContactDetails(false);
                  setShowUpdateAgentUploadsDetails(true);
                  setShowUpdateAgentUserDetails(false);
                  setShowUpdateAgentTariffDetails(false);
                }}
              >
                Uploads
              </Button>
              <Button
                className={`${showUpdateAgentUserDetails ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                style={{ marginRight: 10, width: 120 }}
                onClick={() => {
                  setShowUpdateAgentDetails(false);
                  setShowUpdateAgentContactDetails(false);
                  setShowUpdateAgentUploadsDetails(false);
                  setShowUpdateAgentUserDetails(true);
                  setShowUpdateAgentTariffDetails(false);
                }}
              >
                Users
              </Button>
              <Button
                className={`${showUpdateAgentTariffDetails ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                style={{ marginRight: 10, width: 120 }}
                onClick={() => {
                  setShowUpdateAgentDetails(false);
                  setShowUpdateAgentContactDetails(false);
                  setShowUpdateAgentUploadsDetails(false);
                  setShowUpdateAgentUserDetails(false);
                  setShowUpdateAgentTariffDetails(true);
                }}
              >
                Tariff
              </Button>
            </div>
            <div className="col-4">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                aria-label="Close"
                title="Close"
                onClick={handleUpdateModalClose}
              >
                <i className="fa fa-times text-white"></i>
              </button>
              {canvasUpdateFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => setCanvasUpdateFullScreen(false)}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => setCanvasUpdateFullScreen(true)}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="offcanvas-body">
          {/* Details Tab */}
          {showUpdateAgentDetails && (
            <div style={{ fontSize: 13 }}>
              <div className="row">
                <div className="col-12">
                  <Stepper
                    activeStep={activeStep}
                    styleConfig={{
                      activeBgColor: "#12708C",
                      completedBgColor: "#16576b",
                    }}
                  >
                    {steps.map((label, index) => (
                      <Step
                        label={label}
                        key={index}
                        onClick={() => setActiveStep(index)}
                      />
                    ))}
                  </Stepper>
                </div>
                <div className="col-12">
                  <form onSubmit={updateAgent}>
                    {/* Step 0: Primary Details */}
                    {activeStep === 0 && (
                      <div className="row">
                        <div
                          className={`form-group ${canvasUpdateFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label
                            className="required-label"
                            htmlFor="update_agent_name"
                          >
                            Full Name:{" "}
                            <span className="text-danger">
                              {showUpdateAgentNameError
                                ? "Name is required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            id="update_agent_name"
                            placeholder="Enter Agent Name"
                            value={updateAgentName}
                            onChange={(e) => {
                              setUpdateAgentName(e.target.value);
                              setShowUpdateAgentNameError(false);
                              setShowUpdateValidationError(false);
                              setUpdateValidationErrorArray(
                                buildUpdateErrorMessages(),
                              );
                            }}
                            onBlur={(e) => {
                              setShowUpdateAgentNameError(
                                e.target.value === "",
                              );
                              setUpdateValidationErrorArray(
                                buildUpdateErrorMessages(),
                              );
                            }}
                          />
                        </div>

                        <div
                          className={`form-group ${canvasUpdateFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label
                            className="required-label"
                            htmlFor="update_agent_customer"
                          >
                            Customer Name:{" "}
                          </label>
                          <select
                            className="form-select form-control-sm"
                            id="update_agent_customer"
                            onChange={(e) => getCustomerBranch(e.target.value)}
                          >
                            <option value="">Select Customer</option>
                            {customerData.map((customer) => (
                              <option
                                key={customer.id}
                                value={customer.id}
                                selected={updateAgentCustomer === customer.id}
                              >
                                {customer.name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div
                          className={`form-group ${canvasUpdateFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="update_agent_branch">
                            Customer Branch Name:{" "}
                          </label>
                          <select
                            className="form-select form-control-sm"
                            id="update_agent_branch"
                            value={updateAgentCustomerBranch}
                            onChange={(e) =>
                              setUpdateAgentCustomerBranch(e.target.value)
                            }
                          >
                            <option value="">Select Customer Branch</option>
                            {customerBranchData?.map((branch) => (
                              <option
                                key={branch.id}
                                value={branch.id}
                                selected={
                                  updateAgentCustomerBranch === branch.id
                                }
                              >
                                {branch.port_data?.name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div
                          className={`form-group ${canvasUpdateFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="update_agent_own_office">
                            Own Office?{" "}
                          </label>
                          <select
                            className="form-select form-control-sm"
                            id="update_agent_own_office"
                            value={updateAgentOwnOffice}
                            onChange={(e) =>
                              setUpdateAgentOwnOffice(e.target.value)
                            }
                          >
                            <option value="YES">YES</option>
                            <option value="NO">NO</option>
                          </select>
                        </div>

                        <div
                          className={`form-group ${canvasUpdateFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label
                            className="required-label"
                            htmlFor="update_agent_address_line_1"
                          >
                            Address Line 1:{" "}
                            <span className="text-danger">
                              {showUpdateAgentAddressLine1Error
                                ? "Address is required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            id="update_agent_address_line_1"
                            placeholder="Enter Address"
                            value={updateAgentAddressLine1}
                            onChange={(e) => {
                              setUpdateAgentAddressLine1(e.target.value);
                              setShowUpdateAgentAddressLine1Error(false);
                              setShowUpdateValidationError(false);
                              setUpdateValidationErrorArray(
                                buildUpdateErrorMessages(),
                              );
                            }}
                            onBlur={(e) => {
                              setShowUpdateAgentAddressLine1Error(
                                e.target.value === "",
                              );
                              setUpdateValidationErrorArray(
                                buildUpdateErrorMessages(),
                              );
                            }}
                          />
                        </div>

                        <div
                          className={`form-group ${canvasUpdateFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label
                            className="required-label"
                            htmlFor="update_agent_address_line_2"
                          >
                            Address Line 2:{" "}
                            <span className="text-danger">
                              {showUpdateAgentAddressLine2Error
                                ? "Address is required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            id="update_agent_address_line_2"
                            placeholder="Enter Address"
                            value={updateAgentAddressLine2}
                            onChange={(e) => {
                              setUpdateAgentAddressLine2(e.target.value);
                              setShowUpdateAgentAddressLine2Error(false);
                              setShowUpdateValidationError(false);
                              setUpdateValidationErrorArray(
                                buildUpdateErrorMessages(),
                              );
                            }}
                            onBlur={(e) => {
                              setShowUpdateAgentAddressLine2Error(
                                e.target.value === "",
                              );
                              setUpdateValidationErrorArray(
                                buildUpdateErrorMessages(),
                              );
                            }}
                          />
                        </div>

                        <div
                          className={`form-group ${canvasUpdateFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label
                            className="required-label"
                            htmlFor="update_agent_city"
                          >
                            City:{" "}
                            <span className="text-danger">
                              {showUpdateAgentCityError
                                ? "City is required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            id="update_agent_city"
                            placeholder="Enter City"
                            value={updateAgentCity}
                            onChange={(e) => {
                              setUpdateAgentCity(e.target.value);
                              setShowUpdateAgentCityError(false);
                              setShowUpdateValidationError(false);
                              setUpdateValidationErrorArray(
                                buildUpdateErrorMessages(),
                              );
                            }}
                            onBlur={(e) => {
                              setShowUpdateAgentCityError(
                                e.target.value === "",
                              );
                              setUpdateValidationErrorArray(
                                buildUpdateErrorMessages(),
                              );
                            }}
                          />
                        </div>

                        <div
                          className={`form-group ${canvasUpdateFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label
                            className="required-label"
                            htmlFor="update_agent_pincode"
                          >
                            Pincode:{" "}
                            <span className="text-danger">
                              {showUpdateAgentPincodeError
                                ? updateAgentPincode
                                  ? "Must contain only digits"
                                  : "Required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            id="update_agent_pincode"
                            placeholder="Enter Pincode"
                            value={updateAgentPincode}
                            onChange={(e) => {
                              setUpdateAgentPincode(e.target.value);
                              setShowUpdateAgentPincodeError(false);
                              setShowUpdateValidationError(false);
                              setUpdateValidationErrorArray(
                                buildUpdateErrorMessages(),
                              );
                            }}
                            onBlur={(e) => {
                              const val = e.target.value;
                              setShowUpdateAgentPincodeError(
                                !val || !isNumeric(val),
                              );
                              setUpdateValidationErrorArray(
                                buildUpdateErrorMessages(),
                              );
                            }}
                          />
                        </div>

                        <div
                          className={`form-group ${canvasUpdateFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label
                            className="required-label"
                            htmlFor="update_agent_state"
                          >
                            State:{" "}
                            <span className="text-danger">
                              {showUpdateAgentStateError
                                ? "State is required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            id="update_agent_state"
                            placeholder="Enter State"
                            value={updateAgentState}
                            onChange={(e) => {
                              setUpdateAgentState(e.target.value);
                              setShowUpdateAgentStateError(false);
                              setShowUpdateValidationError(false);
                              setUpdateValidationErrorArray(
                                buildUpdateErrorMessages(),
                              );
                            }}
                            onBlur={(e) => {
                              setShowUpdateAgentStateError(
                                e.target.value === "",
                              );
                              setUpdateValidationErrorArray(
                                buildUpdateErrorMessages(),
                              );
                            }}
                          />
                        </div>

                        <div
                          className={`form-group ${canvasUpdateFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label
                            className="required-label"
                            htmlFor="update_agent_country"
                          >
                            Country:{" "}
                          </label>
                          <select
                            className="form-select form-control-sm"
                            id="update_agent_country"
                            value={updateAgentCountry}
                            onChange={(e) =>
                              setUpdateAgentCountry(e.target.value)
                            }
                          >
                            <option value="">Select Country</option>
                            {countryData?.map((country) => (
                              <option
                                key={country.id}
                                value={country.id}
                                selected={updateAgentCountry === country.id}
                              >
                                {country.long_name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    )}

                    {/* Step 1: Financial Details */}
                    {activeStep === 1 && (
                      <div className="row">
                        <div
                          className={`form-group ${canvasUpdateFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label
                            className="required-label"
                            htmlFor="update_agent_license_number"
                          >
                            License Number:{" "}
                            <span className="text-danger">
                              {showUpdateAgentLicenseNumberError
                                ? "Required"
                                : ""}
                            </span>
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            id="update_agent_license_number"
                            placeholder="Enter License Number"
                            value={updateAgentLicenseNumber}
                            onChange={(e) => {
                              setUpdateAgentLicenseNumber(e.target.value);
                              setShowUpdateAgentLicenseNumberError(false);
                              setShowUpdateValidationError(false);
                              setUpdateValidationErrorArray(
                                buildUpdateErrorMessages(),
                              );
                            }}
                            onBlur={(e) => {
                              setShowUpdateAgentLicenseNumberError(
                                e.target.value === "",
                              );
                              setUpdateValidationErrorArray(
                                buildUpdateErrorMessages(),
                              );
                            }}
                          />
                        </div>

                        <div
                          className={`form-group ${canvasUpdateFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="update_agent_export_contact_number">
                            Export Contact Number:
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            id="update_agent_export_contact_number"
                            placeholder="Enter Export Contact Number"
                            value={updateAgentExportContactNumber}
                            onChange={(e) =>
                              setUpdateAgentExportContactNumber(e.target.value)
                            }
                          />
                        </div>

                        <div
                          className={`form-group ${canvasUpdateFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="update_agent_import_contact_number">
                            Import Contact Number:
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            id="update_agent_import_contact_number"
                            placeholder="Enter Import Contact Number"
                            value={updateAgentImportContactNumber}
                            onChange={(e) =>
                              setUpdateAgentImportContactNumber(e.target.value)
                            }
                          />
                        </div>

                        <div
                          className={`form-group ${canvasUpdateFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="update_agent_gst_number">
                            GST Number:
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            id="update_agent_gst_number"
                            placeholder="Enter GST Number"
                            value={updateAgentGstNumber}
                            onChange={(e) =>
                              setUpdateAgentGstNumber(e.target.value)
                            }
                          />
                        </div>

                        <div
                          className={`form-group ${canvasUpdateFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="update_agent_pan_number">
                            PAN Number:
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            id="update_agent_pan_number"
                            placeholder="Enter PAN Number"
                            value={updateAgentPanNumber}
                            onChange={(e) =>
                              setUpdateAgentPanNumber(e.target.value)
                            }
                          />
                        </div>

                        <div
                          className={`form-group ${canvasUpdateFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="update_agent_invoicing">
                            Invoicing:
                          </label>
                          <select
                            className="form-select form-control-sm"
                            id="update_agent_invoicing"
                            value={updateAgentInvoicing}
                            onChange={(e) =>
                              setUpdateAgentInvoicing(e.target.value)
                            }
                          >
                            <option value="MANDATORY">MANDATORY</option>
                            <option value="NON_MANDATORY">NON MANDATORY</option>
                          </select>
                        </div>

                        <div
                          className={`form-group ${canvasUpdateFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="update_agent_tax_invoice_prefix">
                            Tax Prefix:
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            id="update_agent_tax_invoice_prefix"
                            placeholder="Enter Tax Invoice Prefix"
                            value={updateAgentTaxInvoicePrefix}
                            onChange={(e) =>
                              setUpdateAgentTaxInvoicePrefix(e.target.value)
                            }
                          />
                        </div>

                        <div
                          className={`form-group ${canvasUpdateFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="update_agent_expense_prefix">
                            Expense Prefix:
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            id="update_agent_expense_prefix"
                            placeholder="Enter Expense Prefix"
                            value={updateAgentExpensePrefix}
                            onChange={(e) =>
                              setUpdateAgentExpensePrefix(e.target.value)
                            }
                          />
                        </div>

                        <div
                          className={`form-group ${canvasUpdateFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                        >
                          <label htmlFor="update_agent_center_purchase_count">
                            Center Purchase Count:
                          </label>
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            id="update_agent_center_purchase_count"
                            placeholder="Enter Count"
                            value={updateAgentCenterPurchaseCount}
                            onChange={(e) =>
                              setUpdateAgentCenterPurchaseCount(e.target.value)
                            }
                          />
                        </div>
                      </div>
                    )}
                  </form>

                  {/* Navigation Buttons & Error Tooltip */}
                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-12" : "col-md-12"}`}
                  >
                    <span
                      className="btn btn-inox-green border-0"
                      style={{ width: 200, marginRight: 10 }}
                      onClick={() =>
                        setActiveStep((prev) => Math.max(prev - 1, 0))
                      }
                      disabled={activeStep === 0}
                    >
                      Back
                    </span>

                    {activeStep === 1 ? (
                      <>
                        <Button
                          type="button"
                          className="btn btn-inox-green border-0 canvas-button"
                          style={{ width: 100, marginTop: 20 }}
                          onClick={updateAgent}
                          disabled={hasAnyUpdateError() || showUpdateLoader}
                        >
                          {showUpdateLoader ? (
                            <Spinner
                              className="mx-4"
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            <>
                              <i className="fa fa-edit"></i>{" "}
                              <span className="mx-2">Update Agent</span>
                            </>
                          )}
                        </Button>

                        {(hasAnyUpdateError() || showUpdateValidationError) && (
                          <div className="error-tooltip-wrapper">
                            <Button
                              style={{
                                backgroundColor: "#C21E22",
                                border: "#f82e2e",
                              }}
                              title="Show Errors"
                              className="mx-2"
                              onClick={handleUpdateCheckValidationClick}
                              onMouseLeave={() =>
                                setIsUpdateValidationErrorVisible(false)
                              }
                            >
                              <i className="fa fa-exclamation"></i>
                            </Button>
                            {isUpdateValidationErrorVisible && (
                              <div className="validation-error-tooltip">
                                <ul className="mb-0 px-4">
                                  {updateValidationErrorArray.map(
                                    (error, index) => (
                                      <li
                                        key={index}
                                        className="text-left small pb-0"
                                      >
                                        {error}
                                      </li>
                                    ),
                                  )}
                                </ul>
                              </div>
                            )}
                          </div>
                        )}
                      </>
                    ) : (
                      <span
                        className="btn btn-inox-green border-0 "
                        style={{ width: 200 }}
                        onClick={() =>
                          setActiveStep((prev) =>
                            Math.min(prev + 1, steps.length - 1),
                          )
                        }
                        disabled={activeStep === steps.length - 1}
                      >
                        Next
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Contacts Tab */}
          {showUpdateAgentContactDetails && (
            <div>
              {!showUpdateContactForm ? (
                <form onSubmit={addAgentContact}>
                  <div className="row">
                    <div
                      className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label className="required-label" htmlFor="contact_name">
                        Name:
                        <span className="text-danger">
                          {contactNameError ? " Required" : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="contact_name"
                        placeholder="Enter Name"
                        value={contactName}
                        onChange={(e) => {
                          setContactName(e.target.value);
                          setContactNameError(false);
                          setContactValidationError(false);
                          setContactValidationErrorArray(
                            buildContactErrorMessages(),
                          );
                        }}
                        onBlur={(e) => {
                          setContactNameError(e.target.value === "");
                          setContactValidationErrorArray(
                            buildContactErrorMessages(),
                          );
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasUpdateFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                    >
                      <label
                        className="required-label"
                        htmlFor="contact_responsibility"
                      >
                        Responsibility:
                        <span className="text-danger">
                          {contactResponsibilityError ? " Required" : ""}
                        </span>
                      </label>
                      <select
                        className="form-select form-select-sm"
                        id="contact_responsibility"
                        value={contactResponsibility}
                        onChange={(e) => {
                          setContactResponsibility(e.target.value);
                          setContactResponsibilityError(false);
                          setContactValidationError(false);
                          setContactValidationErrorArray(
                            buildContactErrorMessages(),
                          );
                        }}
                        onBlur={(e) => {
                          setContactResponsibilityError(e.target.value === "");
                          setContactValidationErrorArray(
                            buildContactErrorMessages(),
                          );
                        }}
                      >
                        <option value="">Select Responsibility</option>
                        <option value="REPAIR_VENDOR">Repair Vendor</option>
                        <option value="SURVEYOR">Surveyor</option>
                        <option value="MANAGER">Manager</option>
                        <option value="OPERATIONS">Operations</option>
                        <option value="SALES">Sales</option>
                        <option value="TRADE">Trade</option>
                        <option value="COMMERCIALS">Commercials</option>
                        <option value="CUSTOMER_CARE">Customer Care</option>
                        <option value="DIRECTOR">Director</option>
                        <option value="OWNER">Owner</option>
                        <option value="OTHER">Others</option>
                      </select>
                    </div>

                    <div
                      className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label className="required-label" htmlFor="contact_email">
                        Email:
                        <span className="text-danger">
                          {contactEmailError
                            ? contactEmail
                              ? " Invalid email"
                              : " Required"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="email"
                        className="form-control form-control-sm"
                        id="contact_email"
                        placeholder="Enter Email"
                        value={contactEmail}
                        onChange={(e) => {
                          setContactEmail(e.target.value);
                          setContactEmailError(false);
                          setContactValidationError(false);
                          setContactValidationErrorArray(
                            buildContactErrorMessages(),
                          );
                        }}
                        onBlur={(e) => {
                          const val = e.target.value;
                          setContactEmailError(!val || !validateEmail(val));
                          setContactValidationErrorArray(
                            buildContactErrorMessages(),
                          );
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label
                        className="required-label"
                        htmlFor="contact_mobile"
                      >
                        Mobile:
                        <span className="text-danger">
                          {contactMobileError
                            ? contactMobile
                              ? " Must contain only digits"
                              : " Required"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="contact_mobile"
                        placeholder="Enter Mobile"
                        value={contactMobile}
                        onChange={(e) => {
                          setContactMobile(e.target.value);
                          setContactMobileError(false);
                          setContactValidationError(false);
                          setContactValidationErrorArray(
                            buildContactErrorMessages(),
                          );
                        }}
                        onBlur={(e) => {
                          const val = e.target.value;
                          setContactMobileError(!val || !isNumeric(val));
                          setContactValidationErrorArray(
                            buildContactErrorMessages(),
                          );
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasUpdateFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                    >
                      <label htmlFor="contact_telephone">Telephone:</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="contact_telephone"
                        placeholder="Telephone"
                        value={contactTelephone}
                        onChange={(e) => setContactTelephone(e.target.value)}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasUpdateFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                    >
                      <label htmlFor="contact_fax">Fax:</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="contact_fax"
                        placeholder="Fax"
                        value={contactFax}
                        onChange={(e) => setContactFax(e.target.value)}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasUpdateFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                    >
                      <label htmlFor="contact_status">Status:</label>
                      <select
                        className="form-select form-select-sm"
                        id="contact_status"
                        value={contactStatus}
                        onChange={(e) => setContactStatus(e.target.value)}
                      >
                        <option value="ACTIVE">ACTIVE</option>
                        <option value="INACTIVE">INACTIVE</option>
                      </select>
                    </div>

                    <div
                      className={`form-group ${canvasUpdateFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                    >
                      <label htmlFor="contact_is_default">Is Default:</label>
                      <select
                        className="form-select form-select-sm"
                        id="contact_is_default"
                        value={contactDefault}
                        onChange={(e) => setContactDefault(e.target.value)}
                      >
                        <option value="YES">YES</option>
                        <option value="NO">NO</option>
                      </select>
                    </div>

                    <div
                      className={`form-group ${canvasUpdateFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                    >
                      <Button
                        type="submit"
                        className="btn-inox-green border-0 btn-sm w-100 mt-4"
                        disabled={
                          hasAnyContactError() || showAddAgentContactLoader
                        }
                      >
                        {showAddAgentContactLoader ? (
                          <Spinner
                            className="mx-3"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : (
                          "Add"
                        )}
                      </Button>
                      {(hasAnyContactError() || contactValidationError) && (
                        <div className="error-tooltip-wrapper">
                          <Button
                            style={{
                              backgroundColor: "#C21E22",
                              border: "#f82e2e",
                            }}
                            title="Show Errors"
                            className="mx-2"
                            onClick={() =>
                              setContactValidationErrorVisible(
                                !contactValidationErrorVisible,
                              )
                            }
                            onMouseLeave={() =>
                              setContactValidationErrorVisible(false)
                            }
                          >
                            <i className="fa fa-exclamation"></i>
                          </Button>
                          {contactValidationErrorVisible && (
                            <div className="validation-error-tooltip">
                              <ul className="mb-0 px-4">
                                {contactValidationErrorArray.map(
                                  (error, index) => (
                                    <li
                                      key={index}
                                      className="text-left small pb-0"
                                    >
                                      {error}
                                    </li>
                                  ),
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </form>
              ) : (
                <form onSubmit={updateAgentContact}>
                  <div className="row">
                    <div
                      className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label
                        className="required-label"
                        htmlFor="update_contact_name"
                      >
                        Name:
                        <span className="text-danger">
                          {updateContactNameError ? " Required" : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="update_contact_name"
                        placeholder="Enter Name"
                        value={updateContactName}
                        onChange={(e) => {
                          setUpdateContactName(e.target.value);
                          setUpdateContactNameError(false);
                          setContactUpdateValidationError(false);
                          setContactUpdateValidationErrorArray(
                            buildUpdateContactErrorMessages(),
                          );
                        }}
                        onBlur={(e) => {
                          setUpdateContactNameError(e.target.value === "");
                          setContactUpdateValidationErrorArray(
                            buildUpdateContactErrorMessages(),
                          );
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasUpdateFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                    >
                      <label
                        className="required-label"
                        htmlFor="update_contact_responsibility"
                      >
                        Responsibility:
                        <span className="text-danger">
                          {updateContactResponsibilityError ? " Required" : ""}
                        </span>
                      </label>
                      <select
                        className="form-select form-select-sm"
                        id="update_contact_responsibility"
                        value={updateContactResponsibility}
                        onChange={(e) => {
                          setUpdateContactResponsibility(e.target.value);
                          setUpdateContactResponsibilityError(false);
                          setContactUpdateValidationError(false);
                          setContactUpdateValidationErrorArray(
                            buildUpdateContactErrorMessages(),
                          );
                        }}
                        onBlur={(e) => {
                          setUpdateContactResponsibilityError(
                            e.target.value === "",
                          );
                          setContactUpdateValidationErrorArray(
                            buildUpdateContactErrorMessages(),
                          );
                        }}
                      >
                        <option value="">Select Responsibility</option>
                        <option value="REPAIR_VENDOR">Repair Vendor</option>
                        <option value="SURVEYOR">Surveyor</option>
                        <option value="MANAGER">Manager</option>
                        <option value="OPERATIONS">Operations</option>
                        <option value="SALES">Sales</option>
                        <option value="TRADE">Trade</option>
                        <option value="COMMERCIALS">Commercials</option>
                        <option value="CUSTOMER_CARE">Customer Care</option>
                        <option value="DIRECTOR">Director</option>
                        <option value="OWNER">Owner</option>
                        <option value="OTHER">Others</option>
                      </select>
                    </div>

                    <div
                      className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label
                        className="required-label"
                        htmlFor="update_contact_email"
                      >
                        Email:
                        <span className="text-danger">
                          {updateContactEmailError
                            ? updateContactEmail
                              ? " Invalid email"
                              : " Required"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="email"
                        className="form-control form-control-sm"
                        id="update_contact_email"
                        placeholder="Enter Email"
                        value={updateContactEmail}
                        onChange={(e) => {
                          setUpdateContactEmail(e.target.value);
                          setUpdateContactEmailError(false);
                          setContactUpdateValidationError(false);
                          setContactUpdateValidationErrorArray(
                            buildUpdateContactErrorMessages(),
                          );
                        }}
                        onBlur={(e) => {
                          const val = e.target.value;
                          setUpdateContactEmailError(
                            !val || !validateEmail(val),
                          );
                          setContactUpdateValidationErrorArray(
                            buildUpdateContactErrorMessages(),
                          );
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                    >
                      <label
                        className="required-label"
                        htmlFor="update_contact_mobile"
                      >
                        Mobile:
                        <span className="text-danger">
                          {updateContactMobileError
                            ? updateContactMobile
                              ? " Must contain only digits"
                              : " Required"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="update_contact_mobile"
                        placeholder="Enter Mobile"
                        value={updateContactMobile}
                        onChange={(e) => {
                          setUpdateContactMobile(e.target.value);
                          setUpdateContactMobileError(false);
                          setContactUpdateValidationError(false);
                          setContactUpdateValidationErrorArray(
                            buildUpdateContactErrorMessages(),
                          );
                        }}
                        onBlur={(e) => {
                          const val = e.target.value;
                          setUpdateContactMobileError(!val || !isNumeric(val));
                          setContactUpdateValidationErrorArray(
                            buildUpdateContactErrorMessages(),
                          );
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasUpdateFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                    >
                      <label htmlFor="update_contact_telephone">
                        Telephone:
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="update_contact_telephone"
                        placeholder="Telephone"
                        value={updateContactTelephone}
                        onChange={(e) =>
                          setUpdateContactTelephone(e.target.value)
                        }
                      />
                    </div>

                    <div
                      className={`form-group ${canvasUpdateFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                    >
                      <label htmlFor="update_contact_fax">Fax:</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="update_contact_fax"
                        placeholder="Fax"
                        value={updateContactFax}
                        onChange={(e) => setUpdateContactFax(e.target.value)}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasUpdateFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                    >
                      <label htmlFor="update_contact_status">Status:</label>
                      <select
                        className="form-select form-select-sm"
                        id="update_contact_status"
                        value={updateContactStatus}
                        onChange={(e) => setUpdateContactStatus(e.target.value)}
                      >
                        <option value="ACTIVE">ACTIVE</option>
                        <option value="INACTIVE">INACTIVE</option>
                      </select>
                    </div>

                    <div
                      className={`form-group ${canvasUpdateFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                    >
                      <label htmlFor="update_contact_is_default">
                        Is Default:
                      </label>
                      <select
                        className="form-select form-select-sm"
                        id="update_contact_is_default"
                        value={updateContactDefault}
                        onChange={(e) =>
                          setUpdateContactDefault(e.target.value)
                        }
                      >
                        <option value="YES">YES</option>
                        <option value="NO">NO</option>
                      </select>
                    </div>

                    <div
                      className={`form-group ${canvasUpdateFullScreen ? "col-md-1" : "col-md-1"} text-left mb-4`}
                    >
                      <Button
                        type="submit"
                        className="btn-inox-green border-0 btn-sm w-100 mt-4"
                        disabled={
                          hasAnyUpdateContactError() ||
                          showUpdateAgentContactLoader
                        }
                      >
                        {showUpdateAgentContactLoader ? (
                          <Spinner
                            className="mx-3"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : (
                          "Update"
                        )}
                      </Button>
                      {(hasAnyUpdateContactError() ||
                        contactUpdateValidationError) && (
                        <>
                          <Button
                            style={{
                              backgroundColor: "#C21E22",
                              border: "#f82e2e",
                            }}
                            title="Show Errors"
                            className="mx-2"
                            onClick={() =>
                              setContactUpdateValidationErrorVisible(
                                !contactUpdateValidationErrorVisible,
                              )
                            }
                            onMouseLeave={() =>
                              setContactUpdateValidationErrorVisible(false)
                            }
                          >
                            <i className="fa fa-exclamation"></i>
                          </Button>
                          {contactUpdateValidationErrorVisible && (
                            <div className="validation-error-tooltip">
                              <ul className="mb-0 px-4">
                                {contactUpdateValidationErrorArray.map(
                                  (error, index) => (
                                    <li
                                      key={index}
                                      className="text-left small pb-0"
                                    >
                                      {error}
                                    </li>
                                  ),
                                )}
                              </ul>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </form>
              )}

              {agentContacts.length > 0 ? (
                <DataTable
                  columns={contactcolumns}
                  data={agentContacts}
                  progressPending={contactDataPending}
                  progressComponent={
                    <Spinner
                      className="mx-5 text-inox-green table-spinner"
                      as="span"
                      animation="border"
                      size="lg"
                      role="status"
                      aria-hidden="true"
                    />
                  }
                  noDataComponent={
                    <p className="text-center table-no-data">
                      No Contacts Found
                    </p>
                  }
                  pagination
                  highlightOnHover
                  fixedHeader
                  customStyles={userTableCustomStyles}
                  dense
                />
              ) : (
                <p style={{ marginTop: 100 }}>No Contacts Found</p>
              )}

              <Modal
                size="sm"
                show={deleteAgentContactModal}
                onHide={() => setDeleteAgentContactModal(false)}
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    Delete{" "}
                    <span style={{ fontSize: 10 }}>({updateContactName})</span>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>Do you want to delete this contact?</Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={() => setDeleteAgentContactModal(false)}
                  >
                    Close
                  </Button>
                  <Button variant="danger" onClick={deleteAgentContact}>
                    {showDeleteAgentContactLoader ? (
                      <Spinner
                        className="mx-3 text-white"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      "Delete"
                    )}
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
          )}

          {/* Uploads Tab */}
          {showUpdateAgentUploadsDetails && (
            <div>
              <form onSubmit={updateAgentUploads}>
                <div className="row">
                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <input
                      type="file"
                      className="form-control form-control-sm"
                      id="update_agent_uploads"
                      accept="image/*, .pdf"
                      onChange={(e) => {
                        handleUpdateAgentUploadsFileChange(e.target.files);
                        setUpdateAgentUploadFiles(e.target.files);
                      }}
                      multiple
                    />
                  </div>
                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-10" : "col-md-10"} text-left mb-4`}
                  >
                    <Button
                      type="submit"
                      className="btn-inox-green border-0 btn-sm"
                      disabled={updateAgentUploadFiles.length < 1}
                    >
                      {showAgentUploadFilesLoader ? (
                        <Spinner
                          className="mx-4"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        <span className="px-1">Upload</span>
                      )}
                    </Button>
                  </div>
                </div>
                {updateAgentUploadFiles.length > 0 && (
                  <div className="row">
                    <div
                      className="col-12"
                      style={{ fontSize: 12, textAlign: "left" }}
                    >
                      Files:{" "}
                      {updateAgentUploadFileNames.map((name, index) => (
                        <span key={index}>
                          {index !== 0 ? ", " : ""}
                          <b>{index + 1}:</b> {name}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </form>

              {agentUploads?.length > 0 ? (
                <DataTable
                  columns={agentuploadcolumns}
                  data={agentUploads}
                  progressPending={false}
                  progressComponent={
                    <Spinner
                      className="mx-5 text-inox-green table-spinner"
                      as="span"
                      animation="border"
                      size="lg"
                      role="status"
                      aria-hidden="true"
                    />
                  }
                  noDataComponent={
                    <p className="text-center table-no-data">
                      No Uploads Found
                    </p>
                  }
                  pagination
                  highlightOnHover
                  fixedHeader
                  customStyles={userTableCustomStyles}
                  dense
                />
              ) : (
                <p style={{ marginTop: 100 }}>No Uploads Found</p>
              )}

              <Modal
                size="sm"
                show={deleteAgentUploadModal}
                onHide={() => setDeleteAgentUploadModal(false)}
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    Delete{" "}
                    <span style={{ fontSize: 10 }}>
                      ({deleteAgentUploadFileName})
                    </span>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>Do you want to delete this file?</Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={() => setDeleteAgentUploadModal(false)}
                  >
                    Close
                  </Button>
                  <Button variant="danger" onClick={deleteAgentUploads}>
                    {showDeleteAgentUploadFilesLoader ? (
                      <Spinner
                        className="mx-3 text-white"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      "Delete"
                    )}
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
          )}

          {/* Users Tab */}
          {showUpdateAgentUserDetails && (
            <div
              className="col-12 text-left"
              style={{
                marginTop: -5,
                paddingLeft: 20,
                paddingRight: 30,
                zIndex: 100,
              }}
            >
              <DataTable
                columns={agentusercolumns}
                data={agentUserData}
                progressPending={dataPending}
                progressComponent={
                  <Spinner
                    className="mx-5 text-inox-green table-spinner"
                    as="span"
                    animation="border"
                    size="lg"
                    role="status"
                    aria-hidden="true"
                  />
                }
                noDataComponent={
                  <p className="text-center table-no-data">
                    No Users associated with this agent
                  </p>
                }
                pagination
                highlightOnHover
                fixedHeader
                customStyles={userTableCustomStyles}
                dense
              />
            </div>
          )}

          {/* Tariff Tab */}
          {showUpdateAgentTariffDetails && (
            <div
              className="col-12 text-left"
              style={{
                marginTop: -5,
                paddingLeft: 20,
                paddingRight: 30,
                zIndex: 100,
              }}
            >
              <DataTable
                columns={agenttariffcolumns}
                data={agentTariffData}
                progressPending={dataPending}
                progressComponent={
                  <Spinner
                    className="mx-5 text-inox-green table-spinner"
                    as="span"
                    animation="border"
                    size="lg"
                    role="status"
                    aria-hidden="true"
                  />
                }
                noDataComponent={
                  <p className="text-center table-no-data">
                    No Tariff associated with this agent
                  </p>
                }
                pagination
                highlightOnHover
                fixedHeader
                customStyles={tariffChargeTableCustomStyles}
                dense
              />
            </div>
          )}
        </div>
      </div>

      {/* ------------------------ Add Canvas ------------------- */}
      <div
        className={
          canvasAddFullScreen && showAddCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasAddFullScreen && showAddCanvas
              ? "offcanvas offcanvas-bottom h-50 show"
              : "offcanvas offcanvas-bottom h-50"
        }
        tabIndex="-1"
        aria-labelledby="addCanvasLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="addCanvasLabel" className="float-left">
                Add New Agent
              </h4>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                aria-label="Close"
                title="Close"
                onClick={handleAddModalClose}
              >
                <i className="fa fa-times text-white"></i>
              </button>
              {canvasAddFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => setCanvasAddFullScreen(false)}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => setCanvasAddFullScreen(true)}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="offcanvas-body">
          <div className="row" style={{ fontSize: 13 }}>
            <div className="col-12">
              <Stepper
                activeStep={activeStep}
                styleConfig={{
                  activeBgColor: "#12708C",
                  completedBgColor: "#16576b",
                }}
              >
                {steps.map((label, index) => (
                  <Step
                    label={label}
                    key={index}
                    onClick={() => setActiveStep(index)}
                  />
                ))}
              </Stepper>
            </div>

            <div className="col-12">
              <form onSubmit={addAgent}>
                {/* Step 0: Primary Details */}
                {activeStep === 0 && (
                  <div className="row">
                    <div
                      className={`form-group ${canvasAddFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label
                        className="required-label"
                        htmlFor="add_agent_name"
                      >
                        Full Name:{" "}
                        <span className="text-danger">
                          {showAgentNameError ? "Name is required" : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="add_agent_name"
                        placeholder="Enter Agent Name"
                        value={agentName}
                        onChange={(e) => {
                          setAgentName(e.target.value);
                          setShowAgentNameError(false);
                          setShowValidationError(false);
                          setValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowAgentNameError(e.target.value === "");
                          setValidationErrorArray(buildAddErrorMessages());
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasAddFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label
                        className="required-label"
                        htmlFor="add_agent_customer"
                      >
                        Customer Name:{" "}
                        <span className="text-danger">
                          {showAgentCustomerError ? "Customer is required" : ""}
                        </span>
                      </label>
                      <select
                        className="form-select form-control-sm"
                        id="add_agent_customer"
                        value={agentCustomer}
                        onChange={(e) => {
                          setAgentCustomer(e.target.value);
                          getCustomerBranch(e.target.value);
                          setShowAgentCustomerError(false);
                          setShowValidationError(false);
                          setValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowAgentCustomerError(e.target.value === "");
                          setValidationErrorArray(buildAddErrorMessages());
                        }}
                      >
                        <option value="">Select Customer</option>
                        {customerData.map((customer) => (
                          <option key={customer.id} value={customer.id}>
                            {customer.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div
                      className={`form-group ${canvasAddFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label
                        className="required-label"
                        htmlFor="add_agent_branch"
                      >
                        Customer Branch:{" "}
                        <span className="text-danger">
                          {showAgentCustomerBranchError
                            ? "Branch is required"
                            : ""}
                        </span>
                      </label>
                      <select
                        className="form-select form-control-sm"
                        id="add_agent_branch"
                        value={agentCustomerBranch}
                        onChange={(e) => {
                          setAgentCustomerBranch(e.target.value);
                          setShowAgentCustomerBranchError(false);
                          setShowValidationError(false);
                          setValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowAgentCustomerBranchError(
                            e.target.value === "",
                          );
                          setValidationErrorArray(buildAddErrorMessages());
                        }}
                      >
                        <option value="">Select Branch</option>
                        {customerBranchData?.map((branch) => (
                          <option key={branch.id} value={branch.id}>
                            {branch.port_data?.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div
                      className={`form-group ${canvasAddFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="add_agent_own_office">Own Office?</label>
                      <select
                        className="form-select form-control-sm"
                        id="add_agent_own_office"
                        value={agentOwnOffice}
                        onChange={(e) => setAgentOwnOffice(e.target.value)}
                      >
                        <option value="YES">YES</option>
                        <option value="NO">NO</option>
                      </select>
                    </div>

                    <div
                      className={`form-group ${canvasAddFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label
                        className="required-label"
                        htmlFor="add_agent_address_line_1"
                      >
                        Address Line 1:{" "}
                        <span className="text-danger">
                          {showAgentAddressLine1Error
                            ? "Address is required"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="add_agent_address_line_1"
                        placeholder="Enter Address"
                        value={agentAddressLine1}
                        onChange={(e) => {
                          setAgentAddressLine1(e.target.value);
                          setShowAgentAddressLine1Error(false);
                          setShowValidationError(false);
                          setValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowAgentAddressLine1Error(e.target.value === "");
                          setValidationErrorArray(buildAddErrorMessages());
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasAddFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label
                        className="required-label"
                        htmlFor="add_agent_address_line_2"
                      >
                        Address Line 2:{" "}
                        <span className="text-danger">
                          {showAgentAddressLine2Error
                            ? "Address is required"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="add_agent_address_line_2"
                        placeholder="Enter Address"
                        value={agentAddressLine2}
                        onChange={(e) => {
                          setAgentAddressLine2(e.target.value);
                          setShowAgentAddressLine2Error(false);
                          setShowValidationError(false);
                          setValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowAgentAddressLine2Error(e.target.value === "");
                          setValidationErrorArray(buildAddErrorMessages());
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasAddFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label
                        className="required-label"
                        htmlFor="add_agent_city"
                      >
                        City:{" "}
                        <span className="text-danger">
                          {showAgentCityError ? "City is required" : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="add_agent_city"
                        placeholder="Enter City"
                        value={agentCity}
                        onChange={(e) => {
                          setAgentCity(e.target.value);
                          setShowAgentCityError(false);
                          setShowValidationError(false);
                          setValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowAgentCityError(e.target.value === "");
                          setValidationErrorArray(buildAddErrorMessages());
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasAddFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label
                        className="required-label"
                        htmlFor="add_agent_pincode"
                      >
                        Pincode:{" "}
                        <span className="text-danger">
                          {showAgentPincodeError
                            ? agentPincode
                              ? "Must contain only digits"
                              : "Required"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="add_agent_pincode"
                        placeholder="Enter Pincode"
                        value={agentPincode}
                        onChange={(e) => {
                          setAgentPincode(e.target.value);
                          setShowAgentPincodeError(false);
                          setShowValidationError(false);
                          setValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          const val = e.target.value;
                          setShowAgentPincodeError(!val || !isNumeric(val));
                          setValidationErrorArray(buildAddErrorMessages());
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasAddFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label
                        className="required-label"
                        htmlFor="add_agent_state"
                      >
                        State:{" "}
                        <span className="text-danger">
                          {showAgentStateError ? "State is required" : ""}
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="add_agent_state"
                        placeholder="Enter State"
                        value={agentState}
                        onChange={(e) => {
                          setAgentState(e.target.value);
                          setShowAgentStateError(false);
                          setShowValidationError(false);
                          setValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowAgentStateError(e.target.value === "");
                          setValidationErrorArray(buildAddErrorMessages());
                        }}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasAddFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label
                        className="required-label"
                        htmlFor="add_agent_country"
                      >
                        Country:{" "}
                        <span className="text-danger">
                          {showAgentCountryError ? "Country is required" : ""}
                        </span>
                      </label>
                      <select
                        className="form-select form-control-sm"
                        id="add_agent_country"
                        value={agentCountry}
                        onChange={(e) => {
                          setAgentCountry(e.target.value);
                          setShowAgentCountryError(false);
                          setShowValidationError(false);
                          setValidationErrorArray(buildAddErrorMessages());
                        }}
                        onBlur={(e) => {
                          setShowAgentCountryError(e.target.value === "");
                          setValidationErrorArray(buildAddErrorMessages());
                        }}
                      >
                        <option value="">Select Country</option>
                        {countryData?.map((country) => (
                          <option key={country.id} value={country.id}>
                            {country.long_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}

                {/* Step 1: Financial Details */}
                {activeStep === 1 && (
                  <div className="row">
                    <div
                      className={`form-group ${canvasAddFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label
                        className="required-label"
                        htmlFor="add_agent_license_number"
                      >
                        License Number:{" "}
                        <span className="text-danger">
                          {showAgentLicenseNumberError ? "Required" : ""}
                        </span>
                      </label>
                      <Select
                        id="add_agent_license_number"
                        options={agentLicenseNumberList}
                        components={customComponents}
                        inputValue={agentLicenseNumber}
                        onInputChange={(value, { action }) => {
                          if (
                            action !== "input-blur" &&
                            action !== "menu-close"
                          ) {
                            const upperValue = value.toUpperCase();
                            setAgentLicenseNumber(upperValue);
                            const exists = agentLicenseNumberList.some(
                              (number) =>
                                number.value.toUpperCase() === upperValue,
                            );
                            setAgentLicenseNumberExist(exists);
                            setShowAgentLicenseNumberError(exists);
                          }
                        }}
                        onBlur={() => {
                          const exists = agentLicenseNumberList.some(
                            (number) =>
                              number.value.toUpperCase() ===
                              agentLicenseNumber.toUpperCase(),
                          );
                          setAgentLicenseNumberExist(exists);
                          setShowAgentLicenseNumberError(exists);
                        }}
                        menuIsOpen={
                          agentLicenseNumber.length > 3 &&
                          !agentLicenseNumberExist
                        }
                        noOptionsMessage={() => null}
                        onChange={(selectedOption) => {
                          setAgentLicenseNumberSelected(selectedOption);
                          const exists = agentLicenseNumberList.some(
                            (number) =>
                              number.value.toUpperCase() ===
                              selectedOption.value.toUpperCase(),
                          );
                          setAgentLicenseNumberExist(exists);
                          setShowAgentLicenseNumberError(exists);
                        }}
                        isClearable={false}
                        value={agentLicenseNumberSelected}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasAddFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="add_agent_export_contact_number">
                        Export Contact Number:
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="add_agent_export_contact_number"
                        placeholder="Enter Export Contact Number"
                        value={agentExportContactNumber}
                        onChange={(e) =>
                          setAgentExportContactNumber(e.target.value)
                        }
                      />
                    </div>

                    <div
                      className={`form-group ${canvasAddFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="add_agent_import_contact_number">
                        Import Contact Number:
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="add_agent_import_contact_number"
                        placeholder="Enter Import Contact Number"
                        value={agentImportContactNumber}
                        onChange={(e) =>
                          setAgentImportContactNumber(e.target.value)
                        }
                      />
                    </div>

                    <div
                      className={`form-group ${canvasAddFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="add_agent_gst_number">GST Number:</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="add_agent_gst_number"
                        placeholder="Enter GST Number"
                        value={agentGstNumber}
                        onChange={(e) => setAgentGstNumber(e.target.value)}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasAddFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="add_agent_pan_number">PAN Number:</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="add_agent_pan_number"
                        placeholder="Enter PAN Number"
                        value={agentPanNumber}
                        onChange={(e) => setAgentPanNumber(e.target.value)}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasAddFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="add_agent_invoicing">Invoicing:</label>
                      <select
                        className="form-select form-control-sm"
                        id="add_agent_invoicing"
                        value={agentInvoicing}
                        onChange={(e) => setAgentInvoicing(e.target.value)}
                      >
                        <option value="MANDATORY">MANDATORY</option>
                        <option value="NON_MANDATORY">NON MANDATORY</option>
                      </select>
                    </div>

                    <div
                      className={`form-group ${canvasAddFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="add_agent_tax_invoice_prefix">
                        Tax Prefix:
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="add_agent_tax_invoice_prefix"
                        placeholder="Enter Tax Invoice Prefix"
                        value={agentTaxInvoicePrefix}
                        onChange={(e) =>
                          setAgentTaxInvoicePrefix(e.target.value)
                        }
                      />
                    </div>

                    <div
                      className={`form-group ${canvasAddFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="add_agent_expense_prefix">
                        Expense Prefix:
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="add_agent_expense_prefix"
                        placeholder="Enter Expense Prefix"
                        value={agentExpensePrefix}
                        onChange={(e) => setAgentExpensePrefix(e.target.value)}
                      />
                    </div>

                    <div
                      className={`form-group ${canvasAddFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                    >
                      <label htmlFor="add_agent_center_purchase_count">
                        Center Purchase Count:
                      </label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        id="add_agent_center_purchase_count"
                        placeholder="Enter Count"
                        value={agentCenterPurchaseCount}
                        onChange={(e) =>
                          setAgentCenterPurchaseCount(e.target.value)
                        }
                      />
                    </div>
                  </div>
                )}
              </form>

              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-12" : "col-md-12"}`}
              >
                <span
                  className="btn btn-inox-green border-0"
                  style={{ width: 200, marginRight: 10 }}
                  onClick={() => setActiveStep((prev) => Math.max(prev - 1, 0))}
                  disabled={activeStep === 0}
                >
                  Back
                </span>

                {activeStep === 1 ? (
                  <>
                    <Button
                      type="button"
                      className="btn btn-inox-green border-0 canvas-button"
                      style={{ width: 100, marginTop: 20 }}
                      onClick={addAgent}
                      disabled={hasAnyAddError() || showAddLoader}
                    >
                      {showAddLoader ? (
                        <Spinner
                          className="mx-4"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        <>
                          <i className="fa fa-plus"></i>{" "}
                          <span className="mx-2">Add Agent</span>
                        </>
                      )}
                    </Button>

                    {(hasAnyAddError() || showValidationError) && (
                      <div className="error-tooltip-wrapper">
                        <Button
                          style={{
                            backgroundColor: "#C21E22",
                            border: "#f82e2e",
                          }}
                          title="Show Errors"
                          className="mx-2"
                          onClick={handleCheckValidationClick}
                          onMouseLeave={() =>
                            setIsValidationErrorVisible(false)
                          }
                        >
                          <i className="fa fa-exclamation"></i>
                        </Button>
                        {isValidationErrorVisible && (
                          <div className="validation-error-tooltip">
                            <ul className="mb-0 px-4">
                              {validationErrorArray.map((error, index) => (
                                <li
                                  key={index}
                                  className="text-left small pb-0"
                                >
                                  {error}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}
                  </>
                ) : (
                  <span
                    className="btn btn-inox-green border-0"
                    style={{ width: 200 }}
                    onClick={() =>
                      setActiveStep((prev) =>
                        Math.min(prev + 1, steps.length - 1),
                      )
                    }
                    disabled={activeStep === steps.length - 1}
                  >
                    Next
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AgentMaster;
